// ═══════════════════════════════════════════════════════════════════════════════
// Not-submitted status pill — same shape as StatusBadge (approved), gray styling
// ═══════════════════════════════════════════════════════════════════════════════

type NotSubmittedStatusBadgeProps = {
  label: string;
};

export const NotSubmittedStatusBadge = ({ label }: NotSubmittedStatusBadgeProps) => (
  <span
    className="inline-flex items-center rounded-full border border-gray-500 bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700 dark:border-gray-500 dark:bg-gray-800 dark:text-gray-200"
    role="status"
    aria-label={label}
  >
    {label}
  </span>
);
